import React from 'react';

/**
 * El número de pacientes del día junto al nombre de una agenda, en el selector
 * de agendas y en la cabecera de cada columna (administración, 5/10/2026):
 * «que desde la vista general se sepa de un vistazo cuántos pacientes tiene
 * cada agenda sin necesidad de entrar en ella». Una pastilla discreta con el
 * número, sin emojis. El 0 se enseña, atenuado: «nadie» también es un dato, y
 * no es lo mismo que no saberlo (entonces no hay pastilla).
 *
 * `alDia` = el número es del día que se está mirando. Al pasar de día, hasta
 * que llega el del día nuevo, el de antes se queda invisible pero ocupando su
 * sitio: ni se enseña un número de otro día ni la lista baila.
 *
 * Vivía dentro de CitasPage.jsx; sale a su fichero el 6/10/2026 porque ahora
 * lo usan también el selector de agendas (SelectorAgendas.jsx) y su botón.
 */
export default function NumeroPacientes({ n, alDia, title, testId }) {
  // (El fondo blanco translúcido de la píldora encendida, `sobreOscuro`, se
  // fue con las píldoras el 6/10/2026: en la lista, la marca es la casilla.)
  return (
    <span
      // `relative`: el «N pacientes» para lectores de pantalla (sr-only, que
      // es absoluto) se queda DENTRO de la pastilla. Sin él escapaba de la
      // fila deslizable de las píldoras y en el móvil la página entera se
      // desplazaba de lado hasta 5000 px (comprobado en producción, 5/10/2026).
      // Sigue haciendo falta en la lista del selector (6/10/2026), que se
      // desplaza en vertical.
      className={`relative inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5 rounded-full text-[11px] leading-none font-medium tabular-nums shrink-0 bg-[#2E6E5E]/10 text-[#13231E]${n === 0 ? ' opacity-50' : ''}${alDia ? '' : ' invisible'}`}
      title={alDia ? title : undefined}
      data-testid={testId}
      data-pacientes={n}
      data-al-dia={alDia ? '1' : undefined}
    >
      <span aria-hidden="true">{n}</span>
      <span className="sr-only">{n === 1 ? '1 paciente' : `${n} pacientes`}</span>
    </span>
  );
}
